module.exports = __webpack_public_path__ + "static/media/grass.20172790.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Background/grass.png
// module id = 1096
// module chunks = 0